import { API } from "shared/services";

export function deleteMessage(customerId, messageId) {
  return API.delete(`customers/${customerId}/messages/${messageId}`);
}

export function createMessage(customerId, payload) {
  return API.post(`/customers/${customerId}/messages`, payload);
}

export function sendAttachment({
  customerId,
  base64,
  filename,
  replySources,
  answerMessage,
}) {
  return API.post(`/customers/${customerId}/messages`, {
    message: {
      body: filename,
      message_quoted_id: answerMessage?.id,
      file: {
        data: base64,
        filename: filename,
      },
    },
    reply_sources: replySources,
  });
}

export function getMessages(customerId, page) {
  return API.get(`/customers/${customerId}/messages?page=${page}`);
}
